import { apiRequest } from "../apiRequest";

interface Args {
  token: string;
}
export async function getPasswordReset({ token }: Args): Promise<boolean> {
  await apiRequest({ url: `passwordReset/${token}` });
  return true;
}
